import {AsyncThunkAction} from '@reduxjs/toolkit';
import {AppThunk, AppThunkApiConfig} from '../createStore';
import {handleError} from '../infrastructure';
import {ErrorHandlingResult} from '@lib/infrastructure';

/**
 * Handles the dispatched action unwrapping its result and displays the error as needed
 * @param action
 * @returns A promise with the result
 */
export const withAsyncThunkErrorHandling =
  <TResult>(
    action: () => AsyncThunkAction<TResult, unknown, AppThunkApiConfig>,
  ): AppThunk<Promise<ErrorHandlingResult<TResult>>> =>
  async (dispatch) => {
    try {
      const result = await dispatch(action()).unwrap();
      return {success: true, result};
    } catch (error) {
      handleError(error, dispatch);
      return {success: false, result: error as Error};
    }
  };

/**
 * Handles the dispatched action unwrapping its result and displays the error as needed
 * @param action
 * @returns A promise with the result
 */
export const withThunkErrorHandling =
  <TResult>(action: () => AppThunk<Promise<TResult>>): AppThunk<Promise<ErrorHandlingResult<TResult>>> =>
  async (dispatch) => {
    try {
      const result = await dispatch(action());
      return {success: true, result};
    } catch (error) {
      handleError(error, dispatch);
      return {success: false, result: error as Error};
    }
  };
